export const settingsConstants = {
	LIST_COMPANY_REQUEST: 'LIST_COMPANY_REQUEST',
	LIST_COMPANY_SUCCESS: 'LIST_COMPANY_SUCCESS',
	LIST_COMPANY_FAILURE: 'LIST_COMPANY_FAILURE',

	CREATE_COMPANY_REQUEST: 'CREATE_COMPANY_REQUEST',
	CREATE_COMPANY_SUCCESS: 'CREATE_COMPANY_SUCCESS',
	CREATE_COMPANY_FAILURE: 'CREATE_COMPANY_FAILURE',

	UPDATE_COMPANY_REQUEST: 'UPDATE_COMPANY_REQUEST',
	UPDATE_COMPANY_SUCCESS: 'UPDATE_COMPANY_SUCCESS',
	UPDATE_COMPANY_FAILURE: 'UPDATE_COMPANY_FAILURE'
}